import swal from 'sweetalert2'

import { Box, Button, Text } from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import { useRelations } from '@hooks/useOrderItem'

import handleCallbackAction from '@functions/handleCallbackAction'

import useCampaign from '@hooks/useCampaign'

import type { OrderItemModel } from '@models/types'

import defaultRequestOptions from '@sections/Client/packs/Campaign/defaultRequestOptions'

import type { UseImportProjectMediaPayload } from '../../../hooks/useImportProjectMedia'

type ConfirmCopyToCampaignParams = {
  attachmentIds: number[],
  callbacks: UseImportProjectMediaPayload['callbacks'],
  orderItemId: number,
}

const confirmCopyToCampaign = (params: ConfirmCopyToCampaignParams) => {
  const { attachmentIds, callbacks, orderItemId } = params
  const { copyToCampaign, fetchCampaignImages } = callbacks

  // After the images are copied to the campaign we must refetch campaign images
  // whilst giving the backend job enough time to copy them over before refetching
  const copyPayload = {
    callbacks: {
      action: copyToCampaign,
      afterAction: () => setTimeout(() => fetchCampaignImages(defaultRequestOptions.image), 1000),
      buildActionParams: () => [orderItemId, attachmentIds],
    },
    toastText: 'Media Copied',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, copy it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Copy Media?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(copyPayload)
    }
  })
}

interface OrderItemProps {
  callbacks: UseImportProjectMediaPayload['callbacks'],
  orderItem: OrderItemModel & { attachmentIds: number[] },
}

const OrderItem = (props: OrderItemProps) => {
  const { callbacks, orderItem } = props

  const {
    attachmentIds, campaign_id, options_string, provider_id, service_id, title,
  } = orderItem

  const { service } = useRelations(orderItem)

  const { callbacks: { reviewMedia } } = useCampaign({ id: campaign_id })

  const { creating } = useAttachment()

  return (
    <Box flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box flexDirection="column" maxWidth={['100%', '50%']}>
        {/*
         // @ts-expect-error TS2339 */}
        <Text fontSize="small" variant="ellipsis">{service.title || `Service #${service_id}`}</Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginTop="small"
          variant="ellipsis"
        >
          {`${title} ${options_string}`}
        </Text>
      </Box>

      <Box
        flexDirection={['column', 'row']}
        justifyContent="flex-end"
        marginLeft={[0, 'large']}
        marginTop={['large', 0]}
      >
        <Button
          buttonStyle="secondaryEdit"
          loading={creating}
          onClick={() => confirmCopyToCampaign({ attachmentIds, callbacks, orderItemId: orderItem.id })}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Import ({attachmentIds.length})
        </Button>

        <Button
          as="a"
          buttonStyle="primaryEdit"
          // @ts-expect-error TS2322
          onClick={() => reviewMedia({ id: provider_id })}
          marginLeft={[0, 'medium']}
          marginTop={['medium', 0]}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          target="_blank"
          width={['100%', 'fit-content']}
        >
          View Media
        </Button>
      </Box>
    </Box>
  )
}

export default OrderItem
